var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "plan-feature" } }, [
    _c("div", { staticClass: "feature" }, [
      _c("div", { staticClass: "feature-title" }, [
        _vm._v(_vm._s(_vm.$t("message.aiVoiceAgentFeature"))),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "feature-delete",
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [_c("span", { staticClass: "material-icons" }, [_vm._v("close")])]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "feature-form" }, [
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [
          _vm._v(_vm._s(_vm.$t("message.activeAgentCount"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-input", {
              attrs: { type: "number" },
              model: {
                value: _vm.featureForm.voiceAgentActiveCount,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "voiceAgentActiveCount", $$v)
                },
                expression: "featureForm.voiceAgentActiveCount",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [
          _vm._v(_vm._s(_vm.$t("message.appointmentTracking"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-checkbox", {
              model: {
                value: _vm.featureForm.voiceAgentAppointmentTracking,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.featureForm,
                    "voiceAgentAppointmentTracking",
                    $$v
                  )
                },
                expression: "featureForm.voiceAgentAppointmentTracking",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [
          _vm._v(_vm._s(_vm.$t("message.bulkCallCount"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-input", {
              attrs: { type: "number" },
              model: {
                value: _vm.featureForm.voiceAgentBulkCallCount,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "voiceAgentBulkCallCount", $$v)
                },
                expression: "featureForm.voiceAgentBulkCallCount",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [
          _vm._v(_vm._s(_vm.$t("message.voiceCloning"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-input", {
              attrs: { type: "number" },
              model: {
                value: _vm.featureForm.voiceAgentVoiceCloning,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "voiceAgentVoiceCloning", $$v)
                },
                expression: "featureForm.voiceAgentVoiceCloning",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [
          _vm._v(_vm._s(_vm.$t("message.readyVoiceUsage"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-checkbox", {
              model: {
                value: _vm.featureForm.voiceAgentReadyVoiceOpenAI,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "voiceAgentReadyVoiceOpenAI", $$v)
                },
                expression: "featureForm.voiceAgentReadyVoiceOpenAI",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [
          _vm._v(_vm._s(_vm.$t("message.communityVoiceUsage"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-checkbox", {
              model: {
                value: _vm.featureForm.voiceAgentCommunityVoice,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "voiceAgentCommunityVoice", $$v)
                },
                expression: "featureForm.voiceAgentCommunityVoice",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [
          _vm._v(_vm._s(_vm.$t("message.concurrentCallCount"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-input", {
              attrs: { type: "number" },
              model: {
                value: _vm.featureForm.voiceAgentConcurrentCallCount,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.featureForm,
                    "voiceAgentConcurrentCallCount",
                    $$v
                  )
                },
                expression: "featureForm.voiceAgentConcurrentCallCount",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [
          _vm._v(_vm._s(_vm.$t("message.webAgentFeature"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-checkbox", {
              model: {
                value: _vm.featureForm.voiceAgentWebAgent,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "voiceAgentWebAgent", $$v)
                },
                expression: "featureForm.voiceAgentWebAgent",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [
          _vm._v(_vm._s(_vm.$t("message.callViaChatbot"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-checkbox", {
              model: {
                value: _vm.featureForm.voiceAgentChatbotCall,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "voiceAgentChatbotCall", $$v)
                },
                expression: "featureForm.voiceAgentChatbotCall",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [
          _vm._v(_vm._s(_vm.$t("message.callViaAutomation"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-checkbox", {
              model: {
                value: _vm.featureForm.voiceAgentAutomationCall,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "voiceAgentAutomationCall", $$v)
                },
                expression: "featureForm.voiceAgentAutomationCall",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [
          _vm._v(_vm._s(_vm.$t("message.callViaTables"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-checkbox", {
              model: {
                value: _vm.featureForm.voiceAgentTableCall,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "voiceAgentTableCall", $$v)
                },
                expression: "featureForm.voiceAgentTableCall",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [
          _vm._v(_vm._s(_vm.$t("message.callViaContacts"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-checkbox", {
              model: {
                value: _vm.featureForm.voiceAgentContactCall,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "voiceAgentContactCall", $$v)
                },
                expression: "featureForm.voiceAgentContactCall",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [
          _vm._v(_vm._s(_vm.$t("message.llmSupport"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-select",
              {
                attrs: { mode: "multiple" },
                model: {
                  value: _vm.featureForm.voiceAgentLlmSupport,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "voiceAgentLlmSupport", $$v)
                  },
                  expression: "featureForm.voiceAgentLlmSupport",
                },
              },
              [
                _c("a-select-option", { attrs: { value: "OpenAI" } }, [
                  _vm._v(_vm._s(_vm.$t("message.llmProviderOpenAI"))),
                ]),
                _vm._v(" "),
                _c("a-select-option", { attrs: { value: "Claude" } }, [
                  _vm._v(_vm._s(_vm.$t("message.llmProviderClaude"))),
                ]),
                _vm._v(" "),
                _c("a-select-option", { attrs: { value: "Gemini" } }, [
                  _vm._v(_vm._s(_vm.$t("message.llmProviderGemini"))),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [
          _vm._v(_vm._s(_vm.$t("message.customLlmIntegration"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-checkbox", {
              model: {
                value: _vm.featureForm.voiceAgentCustomLlmIntegration,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.featureForm,
                    "voiceAgentCustomLlmIntegration",
                    $$v
                  )
                },
                expression: "featureForm.voiceAgentCustomLlmIntegration",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [
          _vm._v(_vm._s(_vm.$t("message.customDataTraining"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-checkbox", {
              model: {
                value: _vm.featureForm.voiceAgentCustomDataTraining,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "voiceAgentCustomDataTraining", $$v)
                },
                expression: "featureForm.voiceAgentCustomDataTraining",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [
          _vm._v(_vm._s(_vm.$t("message.ivrFeature"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-checkbox", {
              model: {
                value: _vm.featureForm.voiceAgentIvr,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "voiceAgentIvr", $$v)
                },
                expression: "featureForm.voiceAgentIvr",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [
          _vm._v(_vm._s(_vm.$t("message.customFunctions"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-checkbox", {
              model: {
                value: _vm.featureForm.voiceAgentCustomFunctions,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "voiceAgentCustomFunctions", $$v)
                },
                expression: "featureForm.voiceAgentCustomFunctions",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [
          _vm._v(_vm._s(_vm.$t("message.sentimentAnalysis"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-checkbox", {
              model: {
                value: _vm.featureForm.voiceAgentSentimentAnalysis,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "voiceAgentSentimentAnalysis", $$v)
                },
                expression: "featureForm.voiceAgentSentimentAnalysis",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [
          _vm._v(_vm._s(_vm.$t("message.advancedVoiceSettings"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-checkbox", {
              model: {
                value: _vm.featureForm.voiceAgentAdvancedVoiceSettings,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.featureForm,
                    "voiceAgentAdvancedVoiceSettings",
                    $$v
                  )
                },
                expression: "featureForm.voiceAgentAdvancedVoiceSettings",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [
          _vm._v(_vm._s(_vm.$t("message.secretaryDetection"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-checkbox", {
              model: {
                value: _vm.featureForm.voiceAgentSecretaryDetection,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "voiceAgentSecretaryDetection", $$v)
                },
                expression: "featureForm.voiceAgentSecretaryDetection",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [
          _vm._v(_vm._s(_vm.$t("message.customizablePrompts"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-checkbox", {
              model: {
                value: _vm.featureForm.voiceAgentCustomPrompts,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "voiceAgentCustomPrompts", $$v)
                },
                expression: "featureForm.voiceAgentCustomPrompts",
              },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }